import "./input-range.scss";

import React, { useState } from "react";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";

const RangeInput = ({ priceMin, priceMax, handleRange }) => {
  const [priceRange, setPriceRange] = useState({ min: 0, max: 900 });
  // const numInputs = document.querySelectorAll("input[type=number]");

  // useEffect(() => {
  //   numInputs.forEach(function (input) {
  //     input.addEventListener("change", function (e) {
  //       if (e.target.value == "") {
  //         e.target.value = 0;
  //       }
  //     });
  //   });
  // }, [numInputs]);
  return (
    <div className="input-range-wrapper">
      <div className="input-range-wrapper__title">Cena (w tys. PLN)</div>
      <InputRange
        draggableTrack
        maxValue={900}
        minValue={0}
        step={225}
        onChange={(value) => {
          setPriceRange(value);
          handleRange(priceRange.min, priceRange.max);
        }}
        onChangeComplete={(value) => {
          setPriceRange(value);
          handleRange(priceRange.min, priceRange.max);
        }}
        value={priceRange}
        passChildData={"test"}
        formatLabel={(value) =>
          `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g)}`
        }
      />
      <div className="range-values-container">
        <input
          type="number"
          className="range-values-container__input"
          value={priceRange.min}
          onChange={(e) => setPriceRange({ min: e.target.value, max: 900 })}
        />
        <input
          type="number"
          className="range-values-container__input"
          value={priceRange.max}
          onChange={(e) => setPriceRange({ min: 0, max: e.target.value })}
        />
      </div>
    </div>
  );
};

export default RangeInput;
